// extracted by mini-css-extract-plugin
export default {"yellowText":"IncomingCallModal_yellowText__e5-tj","toNumber":"IncomingCallModal_toNumber__UI30C","greyText":"IncomingCallModal_greyText__VFF7E"};